import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { api } from '@/services/api';
import { LogoFull } from '@/components/Logo';

const LegalPage = ({ type }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = type === 'terms' ? await api.getTerms() : await api.getPrivacy();
        setContent(data);
      } catch (error) {
        console.error('Error fetching legal content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [type]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F0F4F8] flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-[#1A3A64] border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F0F4F8]">
      {/* Header */}
      <header className="bg-white border-b border-[#DCE4ED]">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-[#3D5A80] hover:text-[#0D1B2A]">
              <ArrowLeft size={20} />
              Back to Home
            </Link>
            <Link to="/" className="flex items-center gap-2">
              <LogoFull size="small" />
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl border border-[#DCE4ED] p-8 md:p-12">
          <h1 className="text-3xl font-semibold text-[#0D1B2A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {content?.title}
          </h1>
          <p className="text-sm text-[#8DA0B9] mb-8">
            Effective Date: {content?.effective_date}
          </p>
          
          <div className="prose prose-slate max-w-none">
            <div className="whitespace-pre-wrap text-[#3D5A80] leading-relaxed">
              {content?.content}
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 text-center text-sm text-[#8DA0B9]">
          <Link to="/terms" className="hover:text-[#1A3A64]">Terms of Service</Link>
          <span className="mx-3">•</span>
          <Link to="/privacy" className="hover:text-[#1A3A64]">Privacy Policy</Link>
          <span className="mx-3">•</span>
          <a href="mailto:legal@insurelab.com" className="hover:text-[#1A3A64]">Contact Legal</a>
        </div>
      </main>
    </div>
  );
};

export const TermsPage = () => <LegalPage type="terms" />;
export const PrivacyPage = () => <LegalPage type="privacy" />;

export default LegalPage;
